//---+m*+m+-+-%-+--+-..%*#%mmm%- -.-.-------       ..	  ...-.. -
// ---+-----++-------++*%#+##+%++---/      /\+-+ +.-  .	+-.	.-.m.#..
//-|                 |    ####-++/+       /xxxx\ ..- -+. -.%++.+--..
//.|  SLEDS main JS!  | .-m+####*/        /xxxxxx\+-#..+m+.###+###+ .
//.|                 |.  -.##+*%|       -xxxxxxxx###*+m-#+#.##-+*--.
//.+-----------------+- ######m-\               /%m+-.#-+m%	%m.m+.--.
//.	. #####+%*#m-*#%###########m%\             /+m-+##m+-.---.#*m.
// .. *m-##m###++*-#m########*mmm.--\       /--+m%.+-----.	. %%  .
// 	 .--+-+.*-.+ +--#..**#**m.+	. -+.+-------%---... --*.	  -.  .
// 		-. m--+. .-. -.+m%-.-	   . . ..+.m.. -  .	 - .  .	  --- .
// 		 ..-.		- .-   .		        	- ..  .	 .	.  m

/**
 * @file main.js
 * @author Jake Stark
 * @desc main entry point for SLEDS
 */

window.debugEnabled = true;

// declare dependencies and establish the module closure

define('main',[
  "require",
  // app modules
  "controllers",
  "cardboard/baseViews",
  "views",
  "commonDataSources",
  "commonDataSourceManager",
  "router",
  "cardboard/jQMSetup",
  "cardboard/util",
  // libraries
  "jquery",
  "underscore",
  "slick",
  "backbone",
  "bowser",
  "tablesorter",
  "modernizr",
], function (
  require,
  // app modules
  Controllers,
  BaseViews,
  Views,
  CommonDataSources,
  CommonDataSourceManager,
  AppRouter,
  jQueryMobileSetup,
  Util,

  // libraries
  $,
  _,
  slick,
  Backbone,
  Bowser,
  TableSorter
) {
  /**
   * @module main
   * @desc main entry point for DfPE
   */

  var exports = {};

  window.HSGraduatesToEmployment = true;
  window.abeReport = true;
  console.log("MODULE: main");

  //
  // STUFF TO DO IMMEDIATELY ON MODULE LOAD
  //

  // start loading the common data sources (including the big org list) ASAP,
  // event before the DOM ready or the main module has a chance to load or
  // execute.
  var commonDataSourceManager = new CommonDataSourceManager(),
    commonSourcesLoaded = commonDataSourceManager.fetchCommonDataSources();

  function displayBrowserWarning() {
    var warningSelector;

    if (Bowser.android && !Bowser.chrome) {
      warningSelector = "#androidWarning";
    } else if (Bowser.msie && Bowser.version < 10) {
      warningSelector = "#ie9Warning";
    }
    if (warningSelector) {
      $(warningSelector).show();
    }
  }

  //------------------------------------------------------------
  // Initialization											 |
  //------------------------------------------------------------

  // initial page setup is here.
  $(function () {
    displayBrowserWarning();

    // I know all this is super-wrapped in callbacks, but we
    // need to make sure that jQuery mobile is loaded, AND the
    // DOM is ready before we proceed

    require(["jqMobile"], function () {
      var attemptingCommonSourceLoad = true,
        attempts = 0,
        maxAttempts = 3;

      // set a class if this is iOS6
      if (parseFloat(Bowser.ios && Bowser.version) < 7) {
        $("html").addClass("iOS6");
      }
      var body = document.body; // Safari
      var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers

      function afterCommonSourcesLoaded() {
        // set up the settings window controller
        window.settings = new Controllers.Settings();

        // set up the main workspace controller and feed it
        // dependencies, which needs to happen second because it reads
        // settings from the above settings controller
        window.workspace = new Controllers.MainWorkspaceController({
          commonDataSourceManager: commonDataSourceManager,
          //dynamicTextController: new Controllers.DynamicTextController({
          //    collection: CommonDataSources.dynamicText
          //}),

          // singleton view objects
          questionBarView: new BaseViews.QuestionBarView({
            el: $(".questionBar"),
            model: CommonDataSources.reportInfo,
          }),
          reportListView: new Views.SLEDSReportListView({
            container: "#navDrawer",
            model: CommonDataSources.reportInfo,
          }),

          // misc. singleton controller objects
          mapController: new Controllers.MapController(),
          bubbleMaker: new BaseViews.BubbleMaker(),

          // some needed elements on the page
          $navDrawer: $("#navDrawer"),
          $introLink: $("#introLink"),
        });

        // FOUC fix adapted from one by Mr. Paul Irish
        // http://paulirish.com/2009/avoiding-the-fouc-v3/ (thanks!)
        /* jshint white:false */ (function (H) {
          H.className = H.className.replace(/\bnotReady\b/, "ready");
        })(document.documentElement);
        window.loadingSpinner.stop();

        // instantiate the router and controller machinery! we also
        // need to set up some defaults in the jquery mobile world,
        // which is necessary because we disable its automatic
        // page-flipping so we can have backbone's routing to manage
        // client-side pages
        window.appRouter = new AppRouter();
        Backbone.history.start({
          pushState: false,
        });
        attemptingCommonSourceLoad = false;

        // Start detecting URL
        var repName = location.hash.substring(0, location.hash.indexOf("/"));
        var page;
        var hash = location.hash;

        if (hash.indexOf("/") > -1) {
          repName = hash.substring(0, hash.indexOf("/"));

          gtag("event", "View", {
            event_category: "Report",
            event_label: repName,
          });
        } else {
          if (hash.indexOf("#") > -1) {
            page = hash.substring(1);
            gtag("event", "View", {
              event_category: "Page",
              event_label: page,
            });
          }
        }

        //Send page view to google analytics

        var p = (location.hash.match(/orgId/g) || []).length;

        if (p === 0) p = -2;

        if (
          location.hash.indexOf("newCollegeStudentDemographics") > -1 ||
          location.hash.indexOf("newCollegeStudentEnrollment") > -1 ||
          location.hash.indexOf("collegeGraduates") > -1
        ) {
          //   $(".orgLabel").html("<div class='orgLabel'><span class='main'>College, System, or Region</span></div>");
          window.isCollegePrevReport = true;
          window.isCollegeReport = true;
          window.abeReport = false;
        } else if (p > 0) {
          window.isCollegePrevReport = false;
          window.isCollegeReport = false;
        }
        /*                     if (location.hash.indexOf("outreach") > -1) {
                                            document.getElementById('mapFrame').src = "map.html";
                                        } */

        if (
          location.hash.indexOf("employment") < 1 &&
          location.hash.indexOf("abeEducationOutcomes") < 1 &&
          location.hash.indexOf("collegeTransfers") < 1
        ) {
          $(
            "<div class='or' style='padding-left:25%'><strong>or</strong></div>"
          ).insertBefore(".filters");
          $("<div class='hr'><hr/></div>").insertAfter(".filters");
        }
        if (location.hash.indexOf("videos1") > -1) {
          $("#video1").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD046005.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/PROD046005.mp4' type='video/mp4' /> <source src='videos/PROD046005.webm' type='video/webm' /> <track kind='captions' src='videos/PROD046005.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
        } else if (location.hash.indexOf("videos2") > -1) {
          $("#video2").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD046925.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/PROD046925.mp4' type='video/mp4' /> <source src='videos/PROD046925.webm' type='video/webm' /> <track kind='captions' src='videos/PROD046925.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
        } else if (location.hash.indexOf("videos3") > -1) {
          $("#video3").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/MDE031971.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/MDE031971.mp4' type='video/mp4' /> <source src='videos/MDE031971.webm' type='video/webm' /> <track kind='captions' src='videos/MDE031971.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video1").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
        } else if (location.hash.indexOf("videos4") > -1) {
          $("#video4").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/MDE031969.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/MDE031969.mp4' type='video/mp4' /> <source src='videos/MDE031969.webm' type='video/webm' /> <track kind='captions' src='videos/MDE031969.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video3").html("");
          $("#video1").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
        } else if (location.hash.indexOf("videos5") > -1) {
          $("#video5").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/MDE031970.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/MDE031970.mp4' type='video/mp4' /> <source src='videos/MDE031970.webm' type='video/webm' /> <track kind='captions' src='videos/MDE031970.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video1").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
        } else if (location.hash.indexOf("videos6") > -1) {
          $("#video6").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/ECLDS_ProgramPlanning.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/ECLDS_ProgramPlanning.mp4' type='video/mp4' /> <source src='videos/ECLDS_ProgramPlanning.webm' type='video/webm' /> <track kind='captions' src='videos/ECLDS_ProgramPlanning.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video1").html("");
          $("#video5").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video8").html("");
        } else if (location.hash.indexOf("videos8") > -1) {
          $("#video8").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031972.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/mde031972.mp4' type='video/mp4' /> <source src='videos/mde031972.webm' type='video/webm' /> <track kind='captions' src='videos/mde031972.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video1").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("html,body").scrollTop(10);
        } else if (location.hash.indexOf("learning") > -1) {
          $(".responsive").slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                  infinite: true,
                  dots: true,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ],
          });
        }
        $(".filter").waitUntilExists(function () {
          $(".filters").show();
          $(".filters2").show();
          $(".demoCats").show();

          if (
            this.id == "box_COLLEGE_STATE" ||
            this.id == "box_INSTITUTION_TYPE" ||
            this.id == "box_COLLEGE_SELECTIVITY"
          ) {
            if (this.value !== "&nbsp;" && this.value !== "FOC_NONE") {
              var that3 = this;
              setTimeout(function () {
                that3.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.children[1].children[1].children[0].innerHTML =
                  '<span class="title">Statewide</span> <span class="parent"></span>';
              }, 1000);
              this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement[1].value =
                "";
            }
          }

          $(".filter").change(function (that5) {
            var this2, that;

            if (
              this.id == "box_COLLEGE_STATE" ||
              this.id == "box_INSTITUTION_TYPE" ||
              this.id == "box_COLLEGE_SELECTIVITY"
            ) {

              if (this.value !== "FOC_NONE") {
                that = this;
                setTimeout(function () {

                  that.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.children[1].children[1].children[0].innerHTML =
                    '<span class="title">Statewide</span> <span class="parent"></span>';
                }, 1000);
                this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement[1].value =
                  "";
              }
            }
          });
        });
        $(function () {
          $("#matrix").tablesorter();
        });

        window.subj1show = function () {
          $("#subj1").show();
          $("#subj1").focus();
          $("#subj2").hide();
          $("#subj3").hide();
          $("#subj4").hide();
          $("#subj5").hide();
          $("#subj6").hide();
          $("#subj1link").addClass("active");
          $("#subj2link").removeClass("active");
          $("#subj3link").removeClass("active");
          $("#subj4link").removeClass("active");
          $("#subj5link").removeClass("active");
          $("#subj6link").removeClass("active");
          gtag("event", "View", {
            event_category: "VideoSubject",
            event_label: "navigating sleds",
          });
        };
        window.subj2show = function () {
          $("#subj2").show();
          $("#subj2").focus();
          $("#subj1").hide();
          $("#subj3").hide();
          $("#subj4").hide();
          $("#subj5").hide();
          $("#subj6").hide();
          $("#subj2link").addClass("active");
          $("#subj1link").removeClass("active");
          $("#subj3link").removeClass("active");
          $("#subj4link").removeClass("active");
          $("#subj5link").removeClass("active");
          $("#subj6link").removeClass("active");
          gtag("event", "View", {
            event_category: "VideoSubject",
            event_label: "college enrollment",
          });
        };
        window.subj3show = function () {
          $("#subj3").show();
          $("#subj3").focus();
          $("#subj1").hide();
          $("#subj2").hide();
          $("#subj4").hide();
          $("#subj5").hide();
          $("#subj6").hide();
          $("#subj3link").addClass("active");
          $("#subj1link").removeClass("active");
          $("#subj2link").removeClass("active");
          $("#subj4link").removeClass("active");
          $("#subj5link").removeClass("active");
          $("#subj6link").removeClass("active");
          gtag("event", "View", {
            event_category: "VideoSubject",
            event_label: "percistence and completion",
          });
        };
        window.subj4show = function () {
          $("#subj4").show();
          $("#subj4").focus();
          $("#subj1").hide();
          $("#subj3").hide();
          $("#subj2").hide();
          $("#subj5").hide();
          $("#subj6").hide();
          $("#subj4link").addClass("active");
          $("#subj1link").removeClass("active");
          $("#subj3link").removeClass("active");
          $("#subj2link").removeClass("active");
          $("#subj5link").removeClass("active");
          $("#subj6link").removeClass("active");
          gtag("event", "View", {
            event_category: "VideoSubject",
            event_label: "career and college readiness",
          });
        };
        window.subj5show = function () {
          $("#subj5").show();
          $("#subj5").focus();
          $("#subj1").hide();
          $("#subj3").hide();
          $("#subj4").hide();
          $("#subj2").hide();
          $("#subj6").hide();
          $("#subj5link").addClass("active");
          $("#subj1link").removeClass("active");
          $("#subj3link").removeClass("active");
          $("#subj4link").removeClass("active");
          $("#subj2link").removeClass("active");
          $("#subj6link").removeClass("active");
          gtag("event", "View", {
            event_category: "VideoSubject",
            event_label: "workforce readiness",
          });
        };
        window.subj6show = function () {
          $("#subj6").show();
          $("#subj6").focus();
          $("#subj1").hide();
          $("#subj3").hide();
          $("#subj4").hide();
          $("#subj5").hide();
          $("#subj2").hide();
          $("#subj6link").addClass("active");
          $("#subj1link").removeClass("active");
          $("#subj3link").removeClass("active");
          $("#subj4link").removeClass("active");
          $("#subj5link").removeClass("active");
          $("#subj2link").removeClass("active");
          gtag("event", "View", {
            event_category: "VideoSubject",
            event_label: "community impact",
          });
        };
        var $accordions = $(".js-accordion");
        if ($accordions.length) {
          // init
          $accordions.each(function (index) {
            var $this = $(this);
            ($options = $this.data()),
              ($accordions_headers = $this.find(".js-accordion__header")),
              ($accordions_prefix_classes =
                $options.accordionPrefixClasses || ""),
              ($accordions_multiselectable =
                $options.accordionMultiselectable || ""),
              ($index_accordion = index + 1);

            $this.attr({
              role: "tablist",
              "aria-multiselectable": "true",
              class: $accordions_prefix_classes,
            });

            // multiselectable or not
            if ($accordions_multiselectable === "none") {
              $this.attr("aria-multiselectable", "false");
            }

            $accordions_headers.each(function (index_h) {
              var $that = $(this),
                $text = $that.text(),
                $accordion_panel = $that.next(".js-accordion__panel"),
                $index_header = index_h + 1;

              $accordion_panel.prepend(
                $that
                  .removeClass("js-accordion__header")
                  .addClass($accordions_prefix_classes + "__title")
                  .attr("tabindex", "0")
              );

              $accordion_header = $(
                '<button class="js-accordion__header ' +
                  $accordions_prefix_classes +
                  '__header">' +
                  $text +
                  "</button>"
              );
              $accordion_panel.before($accordion_header);

              $accordion_header.attr({
                "aria-controls":
                  "accordion" + $index_accordion + "_panel" + $index_header,
                "aria-expanded": "false",
                role: "tab",
                id: "accordion" + $index_accordion + "_tab" + $index_header,
                //  "tabindex": "-1",
                "aria-selected": "false",
              });
              $accordion_panel
                .attr({
                  "aria-labelledby":
                    "accordion" + $index_accordion + "_tab" + $index_header,
                  role: "tabpanel",
                  id: "accordion" + $index_accordion + "_panel" + $index_header,
                  "aria-hidden": "true",
                })
                .addClass($accordions_prefix_classes + "__panel");

              // if opened by default
              if ($that.attr("data-accordion-opened") == "true") {
                $accordion_header
                  .attr("aria-expanded", "true")
                  .removeAttr("data-accordion-opened");
                $accordion_panel.attr("aria-hidden", "false");
              }

              // init first one focusable
              if ($index_header === 1) {
                $accordion_header.removeAttr("tabindex");
              }
              // $("#accordion1_tab2").removeAttr( "tabindex" );
            });
          });
        }

        /* Events ---------------------------------------------------------------------------------------------------------- */
        /* click on a tab link */
        $("body")
          .on("focus", ".js-accordion__header", function (event) {
            var $this = $(this),
              $accordion = $this.parent(),
              $all_accordion_headers = $accordion.find(".js-accordion__header");

            // selected
            $all_accordion_headers.attr({
              //   "tabindex": "-1",
              "aria-selected": "false",
            });
            $this.attr("aria-selected", "true").removeAttr("tabindex");
          })
          .on("click", ".js-accordion__header", function (event) {
            var $this = $(this),
              $this_panel = $("#" + $this.attr("aria-controls")),
              $accordion = $this.parent(),
              $accordion_multiselectable = $accordion.attr(
                "aria-multiselectable"
              ),
              $all_accordion_headers = $accordion.find(".js-accordion__header"),
              $all_accordion_panels = $accordion.find(".js-accordion__panel");

            $all_accordion_headers.attr("aria-selected", "false");
            $this.attr("aria-selected", "true");

            // opened or closed?
            if ($this.attr("aria-expanded") == "false") {
              // closed
              $this.attr("aria-expanded", "true");
              $this_panel.attr("aria-hidden", "false");
            } else {
              // opened
              $this.attr("aria-expanded", "false");
              $this_panel.attr("aria-hidden", "true");
            }

            if ($accordion_multiselectable == "false") {
              $all_accordion_panels
                .not($this_panel)
                .attr("aria-hidden", "true");
              $all_accordion_headers.not($this).attr("aria-expanded", "false");
            }

            setTimeout(function () {
              $this.focus();
            }, 0);
            event.preventDefault();
          })
          .on("keydown", ".js-accordion__header", function (event) {
            var $this = $(this),
              $accordion = $this.parent(),
              $all_accordion_headers = $accordion.find(".js-accordion__header"),
              $first_header = $accordion.find(".js-accordion__header").first(),
              $last_header = $accordion.find(".js-accordion__header").last(),
              $prev_header = $this.prevAll(".js-accordion__header").first(),
              $next_header = $this.nextAll(".js-accordion__header").first();

            // strike up or left in the tab => previous tab
            if (
              (event.keyCode == 37 || event.keyCode == 38) &&
              !event.ctrlKey
            ) {
              $all_accordion_headers.attr({
                //    "tabindex": "-1",
                "aria-selected": "false",
              });
              // if we are on first one, activate last
              if ($this.is($first_header)) {
                $last_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $last_header.focus();
                }, 0);
              }
              // else activate previous
              else {
                $prev_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $prev_header.focus();
                }, 0);
              }
              event.preventDefault();
            }
            // strike down or right in the tab => next tab
            else if (
              (event.keyCode == 40 || event.keyCode == 39) &&
              !event.ctrlKey
            ) {
              $all_accordion_headers.attr({
                //      "tabindex": "-1",
                "aria-selected": "false",
              });
              // if we are on last one, activate first
              if ($this.is($last_header)) {
                $first_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $first_header.focus();
                }, 0);
              }
              // else activate next
              else {
                $next_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $next_header.focus();
                }, 0);
              }
              event.preventDefault();
            }
            // strike home in the tab => 1st tab
            else if (event.keyCode == 36) {
              $all_accordion_headers.attr({
                //   "tabindex": "-1",
                "aria-selected": "false",
              });
              $first_header
                .attr("aria-selected", "true")
                .removeAttr("tabindex");
              setTimeout(function () {
                $first_header.focus();
              }, 0);
              event.preventDefault();
            }
            // strike end in the tab => last tab
            else if (event.keyCode == 35) {
              $all_accordion_headers.attr({
                //    "tabindex": "-1",
                "aria-selected": "false",
              });
              $last_header.attr("aria-selected", "true").removeAttr("tabindex");
              setTimeout(function () {
                $last_header.focus();
              }, 0);
              event.preventDefault();
            }
          })
          .on("keydown", ".js-accordion__panel", function (event) {
            var $this = $(this),
              $this_header = $("#" + $this.attr("aria-labelledby")),
              $accordion = $this.parent(),
              $first_header = $accordion.find(".js-accordion__header").first(),
              $prev_header = $this_header
                .prevAll(".js-accordion__header")
                .first(),
              $next_header = $this_header
                .nextAll(".js-accordion__header")
                .first(),
              $last_header = $accordion.find(".js-accordion__header").last();

            // strike up + ctrl => go to header
            if (event.keyCode == 38 && event.ctrlKey) {
              setTimeout(function () {
                $this_header.focus();
              }, 0);
              event.preventDefault();
            }
            // strike pageup + ctrl => go to prev header
            else if (event.keyCode == 33 && event.ctrlKey) {
              if ($this_header.is($first_header)) {
                setTimeout(function () {
                  $last_header.focus();
                }, 0);
                event.preventDefault();
              } else {
                setTimeout(function () {
                  $prev_header.focus();
                }, 0);
                event.preventDefault();
              }
            }
            // strike pagedown + ctrl => go to next header
            else if (event.keyCode == 34 && event.ctrlKey) {
              if ($this_header.is($last_header)) {
                setTimeout(function () {
                  $first_header.focus();
                }, 0);
                event.preventDefault();
              } else {
                setTimeout(function () {
                  $next_header.focus();
                }, 0);
                event.preventDefault();
              }
            }
          });

        $(window).hashchange(function () {
          var n;

          hash = location.hash;

          var reportName;

          if (hash.indexOf("/") > -1) {
            reportName = hash.substring(0, hash.indexOf("/"));
            gtag("event", "View", {
              event_category: "Report",
              event_label: reportName,
            });
          } else {
            if (hash.indexOf("#") > -1) {
              page = hash.substring(1);
              gtag("event", "View", {
                event_category: "Page",
                event_label: page,
              });
            }
          }
          //Send page view event to google analytics

          if (
            hash.indexOf("newCollegeStudentDemographics") > -1 ||
            location.hash.indexOf("newCollegeStudentEnrollment") > -1 ||
            location.hash.indexOf("collegeGraduates") > -1
          ) {
            window.isCollegeReport = true;
            window.abeReport = false;
            $(".orgLabel").html("<span class='main'>College or System</span>");
          } else if (hash.indexOf("collegeTransfers") > -1) {
            window.isCollegeReport = true;
            window.abeReport = false;
            $(".orgLabel").html(
              "<span class='main'>Previous College or System</span>"
            );
          } else if (hash.indexOf("abeEducationOutcomes") > -1) {
            window.isCollegeReport = false;
            window.abeReport = true;
            $(".orgLabel").html(
              "<span class='main'>ABE Program or Consortium</span>"
            );
          } else {
            window.isCollegeReport = false;
          }
          if (hash.indexOf("/news") > -1) {
            $(".blogHead").focus();
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("videos1") > -1) {
            $("#video1").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD046005.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/PROD046005.mp4' type='video/mp4' /> <source src='videos/PROD046005.webm' type='video/webm' /> <track kind='captions' src='videos/PROD046005.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("videos2") > -1) {
            $("#video2").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD046925.jpg' data-setup='{}' style='max-width: 640px;  border: 1px solid black; '> <source src='videos/PROD046925.mp4' type='video/mp4' /> <source src='videos/PROD046925.webm' type='video/webm' /> <track kind='captions' src='videos/PROD046925.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("videos3") > -1) {
            $("#video3").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/MDE031971.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/MDE031971.mp4' type='video/mp4' /> <source src='videos/MDE031971.webm' type='video/webm' /> <track kind='captions' src='videos/MDE031971.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video1").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("videos4") > -1) {
            $("#video4").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/MDE031969.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/MDE031969.mp4' type='video/mp4' /> <source src='videos/MDE031969.webm' type='video/webm' /> <track kind='captions' src='videos/MDE031969.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video3").html("");
            $("#video1").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("videos5") > -1) {
            $("#video5").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/MDE031970.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/MDE031970.mp4' type='video/mp4' /> <source src='videos/MDE031970.webm' type='video/webm' /> <track kind='captions' src='videos/MDE031970.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video1").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("videos6") > -1) {
            $("#video6").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/ECLDS_ProgramPlanning.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/ECLDS_ProgramPlanning.mp4' type='video/mp4' /> <source src='videos/ECLDS_ProgramPlanning.webm' type='video/webm' /> <track kind='captions' src='videos/ECLDS_ProgramPlanning.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video1").html("");
            $("#video5").html("");
            $("#video7").html("");
            $("#video8").html("");
          } else if (location.hash.indexOf("videos8") > -1) {
            $("#video8").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031972.jpg' data-setup='{}' style='max-width: 640px; /* height: 360px; */ border: 1px solid black; '> <source src='videos/mde031972.mp4' type='video/mp4' /> <source src='videos/mde031972.webm' type='video/webm' /> <track kind='captions' src='videos/mde031972.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video1").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("html,body").scrollTop(10);
          } else if (location.hash.indexOf("learning") > -1) {
            $("html,body").scrollTop(10);
            $(".responsive").slick({
              dots: true,
              infinite: false,
              speed: 300,
              slidesToShow: 3,
              slidesToScroll: 4,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                  },
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  },
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
              ],
            });
          }

          //  Backbone.trigger("hashChange");

          // Detect NAEP selection, if not statewide org set org as statewide
          $(".or").each(function (index) {
            this.outerHTML = "";
          });
          $(".hr").each(function (index) {
            this.outerHTML = "";
          });
          if (hash.indexOf("employment") > -1) {
            window.isEmploymentReport = true;
            window.isCollegeReport = false;

            if (hash.indexOf("999999000") == -1) {
              location.hash =
                "#employment/orgId--999999000__groupType--state__employmentCOHORTID--2015__employmentAward--All+Awards__p--1";

              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 1000);
            }
            $(".orgFinder").hide();
          } else if (location.hash.indexOf("abeEducationOutcomes") > -1) {
            $(".orgFinder").show();
          } else if (location.hash.indexOf("collegeTransfers") > -1) {
            $(".orgFinder").show();
          } else {
            $(".orgFinder").show();
            $(
              "<div class='or' style='padding-left:25%'><strong>or</strong></div>"
            ).insertBefore(".filters");
            $("<div class='hr'><hr/></div>").insertAfter(".filters");

            window.isEmploymentReport = false;
          }

          if (hash.indexOf("HSGraduatesToEmployment") > -1) {
            n = (hash.match(/orgId/g) || []).length;

            if (
              !window.HSGraduatesToEmployment &&
              (hash.indexOf("999999000") == -1 || n > 1)
            ) {
              location.hash =
                "#HSGraduatesToEmployment/orgId--999999000__groupType--state__hsGradEmploymentCOHORTID--2020__p--1";

              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 800);
            }
            window.HSGraduatesToEmployment = true;
            window.isCollegeReport = false;
            window.abeReport = false;
            $(".orgLabel").html("<span class='main'>District</span>");
          } else {
            window.HSGraduatesToEmployment = false;
          }

          if (hash.indexOf("abeEducationOutcomes") > -1) {
            n = (hash.match(/orgId/g) || []).length;

            if (
              !window.abeReport &&
              (hash.indexOf("999999000") == -1 || n > 1)
            ) {
              location.hash =
                "#abeEducationOutcomes/orgId--999999000__groupType--state__abeEducationOutcomesCOHORTID--2020__FUNCTIONAL_LEVEL--FOC_NONE__p--1";

              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 800);
            }
            window.HSGraduatesToEmployment = false;
            window.isCollegeReport = false;
            window.abeReport = true;
          } else {
            window.abeReport = false;
          }

          if (hash.indexOf("data") > -1) {
            body.scrollTop = 0;
            html.scrollTop = 0;
          }

          if (
            (window.isCollegeReport && !window.isCollegePrevReport && p > 0) ||
            window.abeReport
          ) {
            window.isCollegePrevReport = true;
            if (hash.indexOf("abeEducationOutcomes") < 0)
              window.abeReport = false;

            n = (hash.match(/orgId/g) || []).length;
            if (n > 1 || hash.indexOf("999999000") == -1) {
              // We only want one pane on the summary report, if we are coming from a page we had more than one open, default to statewide with 1 pane
              if (hash.indexOf("newCollegeStudentEnrollment") > -1) {
                location.hash =
                  "#newCollegeStudentEnrollment/orgId--999999000__groupType--state__ECODEVREGION--FOC_NONE__newCollegeStudentEnrollmentCOHORTID--2020__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("newCollegeStudentDemographics") > -1) {
                location.hash =
                  "#newCollegeStudentDemographics/orgId--999999000__groupType--state__ECODEVREGION--FOC_NONE__newCollegeStudentDemographicsCOHORTID--2020__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("collegeGraduates") > -1) {
                location.hash =
                  "#collegeGraduates/orgId--999999000__groupType--state__collegeGraduatesCOHORTID--2019__collegeGraduatesAward--FOC_NONE__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              }
            }
          } else if (
            !window.isCollegeReport &&
            window.isCollegePrevReport &&
            p > 0
          ) {
            window.isCollegePrevReport = false;

            n = (hash.match(/orgId/g) || []).length;

            // We only want one pane on the summary report, if we are coming from a page we had more than one open, default to statewide with 1 pane
            if (n > 1 || hash.indexOf("999999000") == -1) {
              if (hash.indexOf("highSchoolAcademics") > -1) {
                location.hash =
                  "#highSchoolAcademics/orgId--999999000__groupType--state__COHORTID--2020__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("collegeActivity") > -1) {
                location.hash =
                  "#collegeActivity/orgId--999999000__groupType--state__ECODEVREGION--FOC_NONE__collegeActivityCOHORTID--2019__DISABILITY_TYPE--FOC_NONE__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("stayingInAndCompletingCollege") > -1) {
                location.hash =
                  "#stayingInAndCompletingCollege/orgId--999999000__groupType--state__ECODEVREGION--FOC_NONE__completingCollegeCOHORTID--2018__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("developmentalEducation") > -1) {
                location.hash =
                  "#developmentalEducation/orgId--999999000__groupType--state__ECODEVREGION--FOC_NONE__devEdCOHORTID--2019__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("rigorousCourseTaking") > -1) {
                location.hash =
                  "#rigorousCourseTaking/orgId--999999000__groupType--state__ECODEVREGION--FOC_NONE__rigorousCourseTakingCOHORTID--2020__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              } else if (hash.indexOf("employment") > -1) {
                location.hash =
                  "#employment/orgId--999999000__groupType--state__employmentCOHORTID--2015__employmentAward--All+Awards__p--1";
                setTimeout(function () {
                  Backbone.trigger("reportSet");
                }, 500);
              }
            }
          }
          var p2 = (location.hash.match(/orgId/g) || []).length;
          if (p2 > 0) {
            p++;
          }
        });

        //Prompt Cardstock to get going if it's available
        Backbone.trigger("pageCompletelyLoaded");

        //Open all external links in a new window
        $("a[href^='http:'],a[href^='https:']")
          .not("[href*='" + window.location.host + "']")
          .attr("target", "_blank");

        $("#reportTile_29").before(
          "<div class='ui-header ui-bar-b ui-listview' data-role='header'><h3>College Students</h3></div>"
        );

        $("#reportTile_215").before(
          "<div class='ui-header ui-bar-b ui-listview' data-role='header'><h3>Adult Education Students</h3></div>"
        );

        $.getJSON(
          "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_report_availability_matrix.fex",
          function (json) {
            var tableString =
              " <table border='1' width='100%' id='matrix' class='matrix tablesorter'><thead><tr><th class='headCol headColumnSort'>Data Sources</th><th class='headCol2 headColumnSort'>Agency</th>";
            var years = json.data.years.length;
            for (i = 0; i < years; i++) {
              tableString +=
                "<th class='sorter-false'>" + json.data.years[i].year + "</th>";
            }
            tableString += "</tr></thead><tr>";

            var dataSources = json.data.dataSources.length;
            for (i = 0; i < dataSources; i++) {
              tableString +=
                "<tr ><td style='text-align:left; min-width: 250px;' class='headCol'>" +
                json.data.dataSources[i].dataSource +
                "</td><td class='headCol2'>" +
                json.data.dataSources[i].agency +
                "</td>";

              for (x = 1; x <= years; x++) {
                tableString +=
                  "<td class='" +
                  json.data.dataSources[i]["year" + x] +
                  "'>" +
                  json.data.dataSources[i]["year" + x] +
                  "</td>";
              }
              tableString += "</tr>";
            }
            tableString += "</table>";

            $("#dataMatrix").replaceWith(
              "<div id='dataMatrix'>" + tableString + "</div>"
            );
          }
        );

        setTimeout(function () {
          $("#matrix").tablesorter();
        }, 2000);
      }

      function handleCommonSourceLoadingError(error) {
        attempts++;
        console.log(attempts);

        if (error instanceof Error) {
          $("#loading .techError").html(
            "There was an error during app setup: " +
              "<br />" +
              error.message +
              "<br />" +
              error.stack
          );
        } else {
          if (attempts < maxAttempts) {
            var $spinnerBox = $("#pageLoadingSpinnerBox").show();
            window.loadingSpinner.spin($spinnerBox[0]);
            $("#loading > .message").html("One moment, please...");
            $("#loading > .error").html(
              "We're having trouble loading some of our data sources, retrying..."
            );
            $("#loading .techError").html(
              "<a style='color:#CCE' onclick=\"document.getElementById('errorDetails').style.display = 'block';return false;\" href='#'>Show details</a><br />" +
                "<div style='display:none;' id='errorDetails'>" +
                "<br />HTTP Status " +
                error.status +
                "<br /><br />Message:<br />" +
                $("<div>" + error.responseText + "</div>").text() +
                "</div>"
            );
          }
        }
        Util.reportPromiseException(error);

        if (attempts < maxAttempts) {
          _.delay(function () {
            commonSourcesLoaded = commonDataSourceManager
              .fetchCommonDataSources()
              .then(afterCommonSourcesLoaded)
              .catch(handleCommonSourceLoadingError);
          }, 2000);
        }
        return error;
      }

      // once all data sources are loaded, fire up the main workspace
      // controller object. NOTE: waiting for all of them (and their
      // processing) to complete before we reveal the UI gets rid of jank!

      commonSourcesLoaded
        .then(afterCommonSourcesLoaded)
        .catch(handleCommonSourceLoadingError);
    });
  });

  function goToByScroll(className) {
    // Remove "link" from the ID
    className = className.replace("link", "");
    // Scroll
    $("html,body").animate(
      {
        scrollTop: $("." + className).offset().top,
      },
      "slow"
    );
  }

  return exports;
});

var records_per_page = 8;
var objPathways = [];
var objProgress = [];
var objPredictors = [];
var objPerformance = [];
var objAllPubs = [];
var objSearchPubs = [];

Papa.parse("data/pubs.csv", {
  download: true,
  header: true,
  complete: function (results) {
    var pathCount = 0;
    var progCount = 0;
    var predCount = 0;
    var perfCount = 0;

    objAllPubs = results.data;
    for (i = 0; i < results.data.length; i++) {
      if (results.data[i].Category.indexOf("Pathways") > -1) {
        objPathways[pathCount++] = results.data[i];
      }
      if (results.data[i].Category.indexOf("Progress") > -1) {
        objProgress[progCount++] = results.data[i];
      }
      if (results.data[i].Category.indexOf("Predictors") > -1) {
        objPredictors[predCount++] = results.data[i];
      }
      if (results.data[i].Category.indexOf("Performance") > -1) {
        objPerformance[perfCount++] = results.data[i];
      }
    }
  },
});

function openPub(evt, pubName) {
  var i, x, tablinks;
  x = document.getElementsByClassName("pubDiv");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablink");
  for (i = 0; i < x.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" pubSelected", "");
  }
  document.getElementById(pubName).style.display = "block";
  evt.currentTarget.className += " pubSelected";
  $("#Progress").focus();
}

var current_page = 1;

function prevPage() {
  if (current_page > 1) {
    current_page--;
    changePage(current_page);
  }
}

function nextPage() {
  if (current_page < numPages()) {
    current_page++;
    changePage(current_page);
  }
}

function changePage(page) {
  var btn_next = document.getElementById("btn_next");
  var btn_prev = document.getElementById("btn_prev");
  var listing_table = document.getElementById("listingTable");
  var page_span = document.getElementById("page");
  var numPages_span = document.getElementById("numPages");

  // Validate page
  if (page < 1) page = 1;
  if (page > numPages()) page = numPages();

  listing_table.innerHTML = "";

  for (
    var i = (page - 1) * records_per_page;
    i < page * records_per_page;
    i++
  ) {
    if (i < objPathways.length)
      listing_table.innerHTML +=
        "<li><a href='" +
        objPathways[i].url +
        "' target='_blank'>" +
        objPathways[i].linkText +
        "</a> - " +
        objPathways[i].linkDesc +
        "</li>";
  }

  page_span.innerHTML = page;
  numPages_span.innerHTML = numPages();

  if (page == 1) {
    btn_prev.style.visibility = "hidden";
  } else {
    btn_prev.style.visibility = "visible";
  }

  if (page == numPages()) {
    btn_next.style.visibility = "hidden";
  } else {
    btn_next.style.visibility = "visible";
  }
}

function numPages() {
  return Math.ceil(objPathways.length / records_per_page);
}

var current_page2 = 1;

function prevPage2() {
  if (current_page2 > 1) {
    current_page2--;
    changePage2(current_page2);
  }
}

function nextPage2() {
  if (current_page2 < numPages2()) {
    current_page2++;
    changePage2(current_page2);
  }
}

function changePage2(page2) {
  var btn_next2 = document.getElementById("btn_next2");
  var btn_prev2 = document.getElementById("btn_prev2");
  var listing_table2 = document.getElementById("listingTable2");
  var page2_span = document.getElementById("page2");
  var numPages2_span = document.getElementById("numPages2");

  // Validate page
  if (page2 < 1) page2 = 1;
  if (page2 > numPages2()) page2 = numPages2();

  listing_table2.innerHTML = "";

  for (
    var i = (page2 - 1) * records_per_page;
    i < page2 * records_per_page;
    i++
  ) {
    if (i < objProgress.length)
      listing_table2.innerHTML +=
        "<li><a href='" +
        objProgress[i].url +
        "' target='_blank'>" +
        objProgress[i].linkText +
        "</a> - " +
        objProgress[i].linkDesc +
        "</li>";
  }

  page2_span.innerHTML = page2;
  numPages2_span.innerHTML = numPages2();

  if (page2 == 1) {
    btn_prev2.style.visibility = "hidden";
  } else {
    btn_prev2.style.visibility = "visible";
  }

  if (page2 == numPages2()) {
    btn_next2.style.visibility = "hidden";
  } else {
    btn_next2.style.visibility = "visible";
  }
}

function numPages2() {
  return Math.ceil(objProgress.length / records_per_page);
}
var current_page3 = 1;

function prevPage3() {
  if (current_page3 > 1) {
    current_page3--;
    changePage3(current_page3);
  }
}

function nextPage3() {
  if (current_page3 < numPages3()) {
    current_page3++;
    changePage3(current_page3);
  }
}

function changePage3(page3) {
  var btn_next3 = document.getElementById("btn_next3");
  var btn_prev3 = document.getElementById("btn_prev3");
  var listing_table3 = document.getElementById("listingTable3");
  var page3_span = document.getElementById("page3");
  var numPages3_span = document.getElementById("numPages3");

  // Validate page
  if (page3 < 1) page3 = 1;
  if (page3 > numPages3()) page3 = numPages3();

  listing_table3.innerHTML = "";

  for (
    var i = (page3 - 1) * records_per_page;
    i < page3 * records_per_page;
    i++
  ) {
    if (i < objPredictors.length)
      listing_table3.innerHTML +=
        "<li><a href='" +
        objPredictors[i].url +
        "' target='_blank'>" +
        objPredictors[i].linkText +
        "</a> - " +
        objPredictors[i].linkDesc +
        "</li>";
  }

  page3_span.innerHTML = page3;
  numPages3_span.innerHTML = numPages3();

  if (page3 == 1) {
    btn_prev3.style.visibility = "hidden";
  } else {
    btn_prev3.style.visibility = "visible";
  }

  if (page3 == numPages3()) {
    btn_next3.style.visibility = "hidden";
  } else {
    btn_next3.style.visibility = "visible";
  }
}

function numPages3() {
  return Math.ceil(objPredictors.length / records_per_page);
}

var current_page4 = 1;

function prevPage4() {
  if (current_page4 > 1) {
    current_page4--;
    changePage4(current_page4);
  }
}

function nextPage4() {
  if (current_page4 < numPages4()) {
    current_page4++;
    changePage4(current_page4);
  }
}

function changePage4(page4) {
  var btn_next4 = document.getElementById("btn_next4");
  var btn_prev4 = document.getElementById("btn_prev4");
  var listing_table4 = document.getElementById("listingTable4");
  var page4_span = document.getElementById("page4");
  var numPages4_span = document.getElementById("numPages4");

  // Validate page
  if (page4 < 1) page4 = 1;
  if (page4 > numPages4()) page4 = numPages4();

  listing_table4.innerHTML = "";

  for (
    var i = (page4 - 1) * records_per_page;
    i < page4 * records_per_page;
    i++
  ) {
    if (i < objPerformance.length)
      listing_table4.innerHTML +=
        "<li><a href='" +
        objPerformance[i].url +
        "' target='_blank'>" +
        objPerformance[i].linkText +
        "</a> - " +
        objPerformance[i].linkDesc +
        "</li>";
  }

  page4_span.innerHTML = page4;
  numPages4_span.innerHTML = numPages4();

  if (page4 == 1) {
    btn_prev4.style.visibility = "hidden";
  } else {
    btn_prev4.style.visibility = "visible";
  }

  if (page4 == numPages4()) {
    btn_next4.style.visibility = "hidden";
  } else {
    btn_next4.style.visibility = "visible";
  }
}

function numPages4() {
  return Math.ceil(objPerformance.length / records_per_page);
}

var current_pageAll = 1;

function prevPageAll() {
  if (current_pageAll > 1) {
    current_pageAll--;
    changePageAll(current_pageAll);
  }
}

function nextPageAll() {
  if (current_pageAll < numPagesAll()) {
    current_pageAll++;
    changePageAll(current_pageAll);
  }
}

function changePageAll(pageAll) {
  var btn_nextAll = document.getElementById("btn_nextAll");
  var btn_prevAll = document.getElementById("btn_prevAll");
  var listing_tableAll = document.getElementById("listingTableAll");
  var pageAll_span = document.getElementById("pageAll");
  var numPagesAll_span = document.getElementById("numPagesAll");

  // Validate page
  if (pageAll < 1) pageAll = 1;
  if (pageAll > numPagesAll()) pageAll = numPagesAll();

  listing_tableAll.innerHTML = "";

  for (var i = (pageAll - 1) * 4; i < pageAll * 4; i++) {
    if (i < objAllPubs.length)
      listing_tableAll.innerHTML +=
        "<li><a href='" +
        objAllPubs[i].url +
        "' target='_blank'>" +
        objAllPubs[i].linkText +
        "</a> - " +
        objAllPubs[i].linkDesc +
        "</li>";
  }

  pageAll_span.innerHTML = pageAll;
  numPagesAll_span.innerHTML = numPagesAll();

  if (pageAll == 1) {
    btn_prevAll.style.visibility = "hidden";
  } else {
    btn_prevAll.style.visibility = "visible";
  }

  if (pageAll == numPagesAll()) {
    btn_nextAll.style.visibility = "hidden";
  } else {
    btn_nextAll.style.visibility = "visible";
  }
}

function numPagesAll() {
  return Math.ceil(objAllPubs.length / 4);
}

var current_pageSearch = 1;

function prevPageSearch() {
  if (current_pageSearch > 1) {
    current_pageSearch--;
    changePageSearch(current_pageSearch);
  }
}

function nextPageSearch() {
  if (current_pageSearch < numPagesSearch()) {
    current_pageSearch++;
    changePageSearch(current_pageSearch);
  }
}

function changePageSearch(pageSearch) {
  var btn_nextSearch = document.getElementById("btn_nextSearch");
  var btn_prevSearch = document.getElementById("btn_prevSearch");
  var listing_tableSearch = document.getElementById("listingTableSearch");
  var pageSearch_span = document.getElementById("pageSearch");
  var numPagesSearch_span = document.getElementById("numPagesSearch");

  // Validate page
  if (pageSearch < 1) pageSearch = 1;
  if (pageSearch > numPagesSearch()) pageSearch = numPagesSearch();

  listing_tableSearch.innerHTML = "";

  if (objSearchPubs.length < 1) {
    listing_tableSearch.innerHTML = "<li>No results found.</li>";
  } else {
    for (var i = (pageSearch - 1) * 4; i < pageSearch * 4; i++) {
      if (i < objSearchPubs.length) {
        listing_tableSearch.innerHTML +=
          "<li><a href='" +
          objSearchPubs[i].url +
          "' target='_blank'>" +
          objSearchPubs[i].linkText +
          "</a> - " +
          objSearchPubs[i].linkDesc +
          "</li>";
      }
    }
  }

  pageSearch_span.innerHTML = pageSearch;
  numPagesSearch_span.innerHTML = numPagesSearch();

  if (pageSearch == 1) {
    btn_prevSearch.style.visibility = "hidden";
  } else {
    btn_prevSearch.style.visibility = "visible";
  }

  if (pageSearch == numPagesSearch()) {
    btn_nextSearch.style.visibility = "hidden";
  } else {
    btn_nextSearch.style.visibility = "visible";
  }
}

function numPagesSearch() {
  return Math.ceil(objSearchPubs.length / 4);
}

function pubSearch() {
  var query = $("#pubSearchText").val();
  objSearchPubs = [];
  var j = 0;
  for (i = 0; i < objAllPubs.length; i++) {
    if (inObject(query, objAllPubs[i])) {
      objSearchPubs[j++] = objAllPubs[i];
    }
  }
  changePageSearch(1);
  $("#searchPubs").show();
  $("#AllPubs").hide();
}

function pubReset() {
  $("#searchPubs").hide();
  $("#AllPubs").show();
}

setTimeout(function () {
  changePage(1);
  changePage2(1);
  changePage3(1);
  changePage4(1);
  changePageAll(1);

  /*   var host = location.host;
     
      if ((host.indexOf("test.sleds.mn.gov") > -1) || (host.indexOf("sleds-dev") > -1) || (host.indexOf("sleds-local-trunk") > -1))
            $("#tutVids").show(); */
}, 3000);

function inObject(value, obj) {
  var foundKey;
  $.each(obj, function (key, val) {
    if (val.toLowerCase().indexOf(value.toLowerCase()) > -1) {
      foundKey = key;
      return;
    }
  });
  return foundKey;
}
;
